<script>
import api from '@/helpers/api'
import { required, email, helpers } from 'vuelidate/lib/validators'
import stepHelper from './step-helper'

import startCase from 'lodash/startCase'
import toLower from 'lodash/toLower'
import isEmpty from 'lodash/isEmpty'
export default {
  name: 'form.form.general',
  props: {
    value: { type: Object, default: () => {} }
  },
  mixins: [stepHelper],
  data: vm => ({
    form: {
      vat_number_valid: false,
      vat_number_last_checked_at: null,
      ...vm.value
    }
  }),
  methods: {
    isEmpty,
    validate () {
      return this.__validateForm()
    },
    async onVerifiyVatNumber () {
      if (isEmpty(this.form.vat_number)) return
      let {
        valid,
        vat_number,
        company_name
      } = await api.customers.validateVatNumber({
        vat_number: this.form.vat_number
      })

      this.form = {
        ...this.form,
        legal_name: startCase(toLower(company_name)),
        vat_number,
        vat_number_valid: valid,
        vat_number_last_checked_at: new Date()
      }
    }
  },
  validations () {
    return {
      form: {
        legal_name: {
          required
        },
        /*         customer_number: {
          required,
          async unique (v) {
            return (
              !helpers.req(v) ||
              (await api.customers.customerNumberIsUnique({ value: v }))
            )
          }
        }, */
        vat_number: {
          async unique (v) {
            return (
              !helpers.req(v) ||
              (await api.customers.vatNumberIsUnique({ value: v }))
            )
          }
        },
        primary_email: {
          email
        }
      }
    }
  }
}
</script>
<template>
  <div>
    <b-form-group
      label="Customer N°"
      label-for="customer_number"
      label-cols-sm="3"
    >
      <b-form-input
        id="customer_number"
        v-model="form.customer_number"
        readonly
        :style="{ width: '150px' }"
      ></b-form-input>
    </b-form-group>

    <b-form-group label="VAT N°" label-for="vat_number" label-cols-sm="3">
      <b-input-group :style="{ width: '350px' }">
        <b-form-input
          id="vat_number"
          v-model="form.vat_number"
          autocomplete="vat_number"
          placeholder="Ex. BE27897439743"
          :class="{ 'is-invalid': $v.form.vat_number.$error }"
          aria-describedby="err_vat_number"
          v-on:blur="$v.form.vat_number.$touch()"
          :readonly="form.vat_number_valid && !!form.vat_number_last_checked_at"
        ></b-form-input>
        <b-input-group-append
          is-text
          class="bg-transparent"
          v-if="form.vat_number_valid"
        >
          <i
            class="bx bx-check-shield text-success"
            id="tooltip-valid-vatnumber"
          ></i>
          <b-tooltip target="tooltip-valid-vatnumber" triggers="hover">
            Valid Vat Number<br />
            <small v-if="form.vat_number_last_checked_at">
              Verified on
              {{
                form.vat_number_last_checked_at | moment('DD/MM/YYYY - HH:mm')
              }}</small
            >
          </b-tooltip>
        </b-input-group-append>
        <b-input-group-append
          is-text
          class="bg-transparent"
          v-if="!form.vat_number_valid"
        >
          <i
            class="bx bx-x-circle text-danger"
            id="tooltip-valid-vatnumber"
          ></i>
          <b-tooltip target="tooltip-valid-vatnumber" triggers="hover">
            Invalid Vat Number
          </b-tooltip>
        </b-input-group-append>
        <b-input-group-append>
          <b-btn
            v-if="
              $v.form.vat_number.$dirty &&
                !form.vat_number_valid &&
                !isEmpty(form.vat_number)
            "
            variant="outline-primary"
            v-on:click="onVerifiyVatNumber"
            ><i class="bx bx-check-shield mr-1"></i> Verify</b-btn
          >
        </b-input-group-append>
        <b-form-invalid-feedback id="err_vat_number">
          <template v-if="!$v.form.vat_number.unique"
            >VAT Number is already used!</template
          >
        </b-form-invalid-feedback>
      </b-input-group>
    </b-form-group>
    <b-form-group label="Legal Name" label-for="legal_name" label-cols-sm="3">
      <b-form-input
        id="legal_name"
        v-model="form.legal_name"
        autocomplete="legal_name"
        placeholder="Legal name of the company"
        :style="{ width: '350px' }"
        :class="{ 'is-invalid': $v.form.legal_name.$error }"
        aria-describedby="err_legal_name"
      ></b-form-input>
      <b-form-invalid-feedback id="err_legal_name">
        <template v-if="!$v.form.legal_name.required">
          Legal Name is required
        </template>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Email" label-for="primary_email" label-cols-sm="3">
      <b-form-input
        id="primary_email"
        v-model="form.primary_email"
        type="email"
        autocomplete="new--password"
        placeholder="Primary Email address"
        :style="{ width: '350px' }"
        :class="{ 'is-invalid': $v.form.primary_email.$error }"
        aria-describedby="err_primary_email"
      ></b-form-input>
      <b-form-invalid-feedback id="err_primary_email">
        <template v-if="!$v.form.primary_email.email">
          Must be an Email address
        </template>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Phone" label-for="primary_phone" label-cols-sm="3">
      <b-form-input
        id="primary_phone"
        v-model="form.primary_phone"
        autocomplete="primary_phone"
        placeholder="ex. +32 4565663"
        :style="{ width: '350px' }"
      ></b-form-input>
    </b-form-group>
  </div>
</template>
